module.exports = __webpack_public_path__ + "img/image_1.dd655a88.jpg";